import { useI18n } from '../i18n.tsx';
import type { RaceWithVerification } from '../types.ts';
import { StatusBadge } from './StatusBadge.tsx';

export function RaceCard({
  race,
  onOpen,
}: {
  race: RaceWithVerification;
  onOpen: (race: RaceWithVerification) => void;
}) {
  const { t, formatDate } = useI18n();
  const status = race.verification?.status ?? 'unverified';

  return (
    <button type="button" className="race-card" onClick={() => onOpen(race)}>
      <div className="top">
        <span className="race-date">
          {formatDate(race.startDate, race.endDate)}
          {race.datePrecision === 'month' && (
            <span className="approx" title={t.approxDate}>
              {' '}
              ≈
            </span>
          )}
        </span>
        <StatusBadge status={status} />
      </div>

      <div>
        <div className="race-name">{race.name}</div>
        <div className="race-where">
          {race.location} · {race.county} · {race.area}
        </div>
      </div>

      <div className="race-stats">
        <span className="chip km">
          {race.half.km} km
          {race.half.elevationM ? ` · +${race.half.elevationM} m` : ''}
        </span>
        <span className="chip">{t.terrainLabels[race.terrain]}</span>
        {race.itra && <span className="chip itra">ITRA</span>}
      </div>
    </button>
  );
}
